import { useIntl } from 'react-intl';

import styles from './collection.module.scss';

import { ReactComponent as IconShare } from '../../../../../assets/images/share.svg';
import { copyToClipboard } from '../../../../../utils';
import pushToDataLayer from '../../../../../utils/pushToDataLayer';
import Button, { ButtonKind } from '../../button/Button';
import Tooltip from '../../tooltip';

const ShareButton = ({ isHideText }: { isHideText?: boolean }) => {
    const intl = useIntl();

    return (
        <Tooltip
            message={intl.formatMessage({ id: 'collection.linkCopied', defaultMessage: 'Link kopiert!' })}
            position={'top'}
        >
            <Button
                kind={ButtonKind.LINK}
                className={styles.shareBtn}
                onClick={async () => {
                    pushToDataLayer('pf_collection_share_click');
                    await copyToClipboard(window.location.href);
                }}
            >
                <IconShare />
                {isHideText ? '' : intl.formatMessage({ id: 'collection.shareButton', defaultMessage: 'Auswahl teilen' })}
            </Button>
        </Tooltip>
    );
};

export default ShareButton;
